import { gql } from "graphql-request";


export const UPDATE_TENANT = gql`
  mutation UpdateTenant($input: UpdateTenantInput!) {
    updateTenant(input: $input) {
      id
      companyID
      name
      status
      slug
      logoUrl
      primaryColor
      secondaryColor
      updatedAt
      archivedAt
    }
  }
`;

export const ARCHIVE_TENANT = gql`
  mutation ArchiveTenant($id: ID!) {
    archiveTenant(id: $id)
  }
`;

export const LOGIN = gql`
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      token
      user {
        id
        firstName
        lastName
        email
        role
      }
    }
  }
`;

